module.exports = __webpack_public_path__ + "img/reduced_before_fer.36df7094.jpg";